import { render } from "./PoolSettingsView.vue?vue&type=template&id=12b08f5c&scoped=true"
import script from "./PoolSettingsView.vue?vue&type=script&lang=js"
export * from "./PoolSettingsView.vue?vue&type=script&lang=js"

import "./PoolSettingsView.vue?vue&type=style&index=0&id=12b08f5c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12b08f5c"]])

export default __exports__